import axios from 'axios';
import authHeader from '../auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/game/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/game/';

class GameService {
  getGame(gameId) {
    return axios.get(API_URL + gameId);
  }

  getGameVideoDetail(gameId, clientId) {
    return axios.get(API_URL + gameId + '/client/' + clientId);
  }

  getGameInfoOfTeamBetweenDates(teamId, from, to){
    return axios.get(API_URL + 'team/' + teamId + '/from/' + from + '/to/' + to);
  }

  getGameInfoOfGames(gameIds){
    return axios.get(API_URL + 'games-info/' + gameIds);
  }

  getGameStats(gameId) {
    return axios.get(API_URL + "stats/game/" + gameId);
  }

  getGameStatsByTemplate(gameId, gameH2HId, homeTeamId, awayTeamId) {
    return axios.get(API_URL + "stats/game/" + gameId + "/template/" + gameH2HId + "/home-team/" + homeTeamId + "/away-team/" + awayTeamId);
  }

  getGamePhysicalStats(gameId) {
    return axios.get(API_URL + "stats-pd/game/" + gameId);
  }

  getGameSummaryStats(gameId) {
    return axios.get(API_URL + gameId + "/summary-stats");
  }

  getByDate(date) {
    return axios.get(`${API_URL}by-date/${date}`);
  }

  getByDateAndLeagueId(dateFrom, dateTo, leagueIds) {
    return axios.get(`${API_URL}by-league/${leagueIds}/date-from/${dateFrom}/to/${dateTo}`);
  }

  getStartingTeamsOfGame(gameId) {
    return axios.get(API_URL + 'starting-teams/' + gameId);
  }

  getStartingTeamsOfGames(gameIds) {
    return axios.get(API_URL + 'starting-teams/all/' + gameIds);
  }

  getGameItems(gameId) {
    return axios.get(API_URL + 'game-items/' + gameId);
  }

  getXGShots(gameId) {
    return axios.get(API_URL + 'xg-shots/' + gameId.toString() + '/players/0/areas/0/strategies/0/type-of-shots/0/body-parts/0/');
  }

  getXGShotsOfSinglePlayer(playerId, playerPosition) {
    return axios.get(API_URL + 'xg-shots/player/' + playerId + '/position/' + playerPosition + '/areas/0/strategies/0/type-of-shots/0/body-parts/0/');
  }

  getXGShotsOfPlayer(gameId, playerId) {
    return axios.get(API_URL + 'xg-shots/' + gameId.toString() + '/players/' + playerId + '/areas/0/strategies/0/type-of-shots/0/body-parts/0/');
  }

  getXGShotsOfTeam(teamId,seasonIds) {
    return axios.get(`${API_URL}xg-shots/team/${teamId}/areas/0/strategies/0/type-of-shots/0/body-parts/0/seasons/${seasonIds}`);
  }

  getXAPasses(gameId) {
    return axios.get(API_URL + 'xa-passes/' + gameId.toString() + '/players/0/areas/0/strategies/0/type-of-shots/0/body-parts/0/');
  }

  getXAPassesOfSinglePlayer(playerId) {
    return axios.get(API_URL + 'xa-passes/player/' + playerId + '/areas/0/strategies/0/type-of-shots/0/body-parts/0/');
  }

  getXAPassesOfTeam(teamId,seasonIds) {
    return axios.get(`${API_URL}xa-passes/team/${teamId}/areas/0/strategies/0/type-of-shots/0/body-parts/0/seasons/${seasonIds}`);
  }

  getXAPassesOfPlayer(gameId, playerId) {
    return axios.get(API_URL + 'xa-passes/' + gameId.toString() + '/players/' + playerId + '/areas/0/strategies/0/type-of-shots/0/body-parts/0/');
  }

  getXTOfGame(gameId) {
    return axios.get(API_URL  + 'xt/' + gameId, { headers: authHeader() });
  }

  getLatestGamesPlayed(teamId, numberOfGames) {
    return axios.get(API_URL + 'latest-games-played/' + teamId + '/n/' + numberOfGames);
  }

  getSimpleLatestGamesPlayed(teamId, numberOfGames) {
    return axios.get(API_URL + 'latest-games-played-simple/' + teamId + '/n/' + numberOfGames);
  }

  getLatestGamesPlayedInLeague(leagueId, numberOfGames) {
    return axios.get(API_URL + 'latest-games-played-league/' + leagueId + '/n/' + numberOfGames);
  }

  getLatestMatchdayGames(seasonId) {
    return axios.get(API_URL + 'latest-matchday-games/' + seasonId );
  }

  getNextMatchdayGames(seasonId){
    return axios.get(API_URL + 'next-matchday-games/' + seasonId );
  }

  getMatchdayGames(seasonId,matchday){
    return axios.get(API_URL + 'matchday-games/' + seasonId + "/" + matchday );
  }

  getNextGames(teamId, numberOfGames) {
    return axios.get(API_URL + 'next-games/' + teamId + '/n/' + numberOfGames);
  }

  getNextGamesBySeasonId(seasonId, days) {
    return axios.get(API_URL + 'next-season-games/' + seasonId + '/days/' + days);
  }

  getGamePassMapData(gameId, minFrom, minTo, periodId) {
    return axios.get(API_URL + gameId + '/pass-map/from/' + minFrom + '/to/'+ minTo + '/period/' + periodId);
  }

  getPlayerDataPassMap(gameId, minFrom, minTo, periodId) {
    return axios.get(API_URL + gameId + '/passes-data/from/' + minFrom + '/to/'+ minTo + '/period/' + periodId);
  }

  getAvgPlayersPositionsPassMap(gameId, minFrom, minTo, periodId, isHomeTeam) {
    return axios.get(API_URL + gameId + '/players-position/from/' + minFrom + '/to/'+ minTo + '/period/' + periodId + '/team/' + isHomeTeam);
  }

  getLatestGamesNationalPLayers(countryId,numberOfPlayers =10) {
    return axios.get(`${API_URL}latest-games-national-players/${countryId}/n/${numberOfPlayers}`);
  }
  /* Used in Game Flow Component  and Post Game Analysis (step 3)*/
  getGameFlowMetricsPerMins(gameId, period, minuteFrom, minuteTo){
    return axios.get(API_URL + "xT/game/"+ gameId + "/game-metrics/period/" + period + "/from/" + minuteFrom + "/to/" + minuteTo);
  }
  /* Used in Post Game Analysis Component (step 1)*/
  getGameInfo(gameId){
    return axios.get(API_URL + 'game-info/' + gameId);
  }
  /* Used in Post Game Analysis Component (step 1 and 2) */
  getGameMetrics(gameId, homeTeamId){
    return axios.get(API_URL + gameId + "/game-metrics/" + homeTeamId);
  }
  /* Used in Game Component (Table) */
  getAdvancedGameMetrics(gameId){
    return axios.get(API_URL + gameId + "/advanced-game-metrics/");
  }
  /* Used in Post Game Analysis (step 4)*/
  getDataTablesMetricsPerPhases(gameId, period, minuteFrom, minuteTo){
    return axios.get(API_URL + gameId + "/game-metrics-per-phases/period/" + period + "/from/" + minuteFrom + "/to/" + minuteTo);
  }

  getCompletedGamesByTeamAndSeasons(teamId,seasonIds){
    return axios.get(`${API_URL}team/${teamId}/season/${seasonIds}/completed`);
  }
  /* Used in GamePossessionMap */
  getGamePossessions(gameId){
    return axios.get(API_URL + gameId + "/possessions");
  }

  getEvents(matchIds,playerIds,events,zonesFrom,zonesTo,minFrom,minTo){
    return axios.get(`${API_URL}${matchIds}/players/${playerIds}/events/${events}/zones-from/${zonesFrom}/zones-to/${zonesTo}/from/${minFrom}/to/${minTo}`);
  }

  getGamesToProcess(){
    return axios.get(API_URL + "to-process",{timeout: 2000});
  }

  processEventPlayerPositions(gameId,shotId,processObject,confirmed,saveCamera){
    return axios.post(`${API_URL}${gameId}/process/${shotId}/event-players-positions`,processObject,{
      params: {
        confirmed,
        cp:saveCamera
      }
    });
  }

  updateHomeAttackLeft(game){
    return axios.put(API_URL + game.gameId + "/update-attack-left/"+game.homeAttackLeftFirstHalf,null);
  }

  getPlayerEventPositions(gameId,shotId){
    return axios.get(API_URL + `${gameId}/shot/${shotId}/event-players-positions`);
  }

  getVideoEvents(gameId){
    return axios.get(API_URL + `${gameId}/video-events`);
  }

  getVideoEventsAdvanced(gameIds, playerIds){
    return axios.get(`${API_URL}${gameIds}/players/${playerIds}/video-events`);
  }

  getVideoURL(gameId,filename){
    return axios.get(API_URL + `${gameId}/downloadURL/${filename}`);
  }

  postGameUploadVideo(gameObject){
    return axios.post(API_URL + `upload-video`,gameObject);
  }

  getUploadedGames(page = 0, size = '999999', sort = 'g.matchDate,desc'){
    return axios.get(API_URL + `uploaded`, { params: { page, size, sort }});
  }

  postKora(obj){
    return axios.post("https://korastats.com/ks10/api.php?module=api&api=MatchRequest&version=V2&response=json&key=RHJpYmxhYjpAMTIzNDVA",obj)
  }

  postGameReviewed(gameId) {
    return axios.post(API_URL + `${gameId}/reviewed`)
  }

  postBackKora(gameId,obj){
    return axios.post(API_URL + `${gameId}/send-kora`,obj)
  }

  updateNotesOfUploadedGame(gameObject){
    return axios.put(API_URL + `uploaded/notes`, gameObject);
  }

  getRelevantPlays(gameId){
    return axios.get(API_URL + `${gameId}/relevant-plays`);
  }

  updateOffsetOfUploadedGame(gameObject){
    return axios.put(API_URL + `uploaded/offset`, gameObject);
  }

  updateFullVideoOfUploadedGame(gameObject){
    return axios.put(API_URL + `uploaded/full-video`, gameObject);
  }

  updateRequestedOfUploadedGame(gameObject){
    return axios.put(API_URL + `uploaded/requested`, gameObject);
  }

  updateRejectedOfUploadedGame(gameObject){
    return axios.put(API_URL + `uploaded/rejected`, gameObject);
  }

  updateFiles(gameId,clientGameVideoId,gameObject){
    return axios.put(`${API_URL}${gameId}/${clientGameVideoId}/files`, gameObject);
  }

  deleteGameFile(gameId,clientGameVideoId,typeId){
    return axios.delete(`${API_URL}${gameId}/${clientGameVideoId}/${typeId}`);
  }

  getGamePlayerStatsByTemplate(seasonIds, gameH2HId, playerId) {
    return axios.get(API_URL + "stats/season/" + seasonIds + "/player/" + playerId + "/template/" + gameH2HId);
  }

}

export default new GameService();



// WEBPACK FOOTER //
// ./src/services/game/game.service.js